var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80922 4.99768L5.77981 1.21766C5.84926 1.15326 5.90467 1.0752 5.94255 0.988391C5.98044 0.901579 6 0.807878 6 0.713156C6 0.618434 5.98044 0.524732 5.94255 0.43792C5.90467 0.351108 5.84926 0.273056 5.77981 0.208653C5.63552 0.0745419 5.44584 0 5.24887 0C5.05189 0 4.86221 0.0745419 4.71792 0.208653L0.218389 4.49268C0.151359 4.55537 0.0975265 4.63081 0.0600534 4.71459C0.0225804 4.79837 0.00222096 4.8888 0.00017178 4.98055C-0.0018774 5.07231 0.0144249 5.16355 0.0481204 5.24892C0.0818159 5.33429 0.132226 5.41207 0.196391 5.47769L4.71392 9.79171C4.85831 9.9256 5.04796 10 5.24487 10C5.44178 10 5.63141 9.9256 5.77581 9.79171C5.84526 9.72731 5.90066 9.64926 5.93855 9.56244C5.97644 9.47563 5.996 9.38193 5.996 9.28721C5.996 9.19249 5.97644 9.09879 5.93855 9.01197C5.90066 8.92516 5.84526 8.84711 5.77581 8.78271L1.80922 4.99768Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f58ce0b0bd538926e1c9a1cdb5c5630b.svg";
export { ForwardRef as ReactComponent };